export default __webpack_public_path__ + "media/images/home-illustration-6ea2e70b.jpg";